import React, { useState, useEffect } from 'react';

const ServiceCategoryModal = ({ isOpen, onClose, category, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    order: 0
  });

  useEffect(() => {
    if (category) {
      setFormData({
        name: category.name || '',
        order: category.order || 0
      });
    } else {
      setFormData({
        name: '',
        order: 0
      });
    }
  }, [category, isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80">
      <div className="glass rounded-2xl max-w-md w-full">
        <div className="p-6 border-b border-white/10 flex justify-between items-center">
          <h2 className="text-2xl font-semibold">
            {category ? 'Kategória szerkesztése' : 'Új kategória'}
          </h2>
          <button onClick={onClose} className="text-2xl hover:text-yellow-200">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm text-gray-400 mb-2">Név *</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
              className="w-full px-4 py-3 bg-black/30 border border-white/10 rounded-lg focus:border-yellow-200/50 focus:outline-none text-white"
              placeholder="Numerológia"
            />
          </div>

          <div>
            <label className="block text-sm text-gray-400 mb-2">Sorrend</label>
            <input
              type="number"
              value={formData.order}
              onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) })}
              min="0"
              className="w-full px-4 py-3 bg-black/30 border border-white/10 rounded-lg focus:border-yellow-200/50 focus:outline-none text-white"
            />
            <p className="text-xs text-gray-500 mt-1">A kategóriák rendezési sorrendje</p>
          </div>

          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-6 py-3 bg-white/5 hover:bg-white/10 rounded-lg transition"
            >
              Mégse
            </button>
            <button
              type="submit"
              className="flex-1 px-6 py-3 bg-yellow-200 text-black font-semibold rounded-lg hover:bg-yellow-300 transition"
            >
              Mentés
            </button>
          </div>
        </form>
      </div>

      <style jsx>{`
        .glass {
          background: linear-gradient(180deg, hsl(0 0% 100% / 0.08), hsl(0 0% 100% / 0.04));
          border: 1px solid hsl(0 0% 100% / 0.1);
          backdrop-filter: blur(12px);
        }
      `}</style>
    </div>
  );
};

export default ServiceCategoryModal;
